import { render } from "./Category3DModel.vue?vue&type=template&id=0a1bcbcc&scoped=true"
import script from "./Category3DModel.vue?vue&type=script&lang=js"
export * from "./Category3DModel.vue?vue&type=script&lang=js"

import "./Category3DModel.vue?vue&type=style&index=0&id=0a1bcbcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1bcbcc"]])

export default __exports__